/* eslint-disable import/prefer-default-export */
import axios from '../axios';

// ---------------------------------------------------------------------------
// PDVs — leitura de catálogo.
//
// `GET /pdvs` é endpoint legado de Geração 1: responde ora um array cru, ora
// `{ pdvs: [...] }`, ora o envelope JSend (as telas de snapshot já convivem com
// as três formas). O leitor defensivo mora aqui para que o código novo consuma
// sempre uma lista.
//
// Diferença de escopo que importa: `/users/me/pdvs` (hook `useUserPdvs`) traz
// só os PDVs do usuário — é o que gateia a ORIGEM de uma transferência; este
// endpoint traz o catálogo completo, usado no DESTINO (que pode ser qualquer
// PDV, inclusive um que o usuário não opera).
// ---------------------------------------------------------------------------

export async function listPdvs() {
   const response = await axios.get('/pdvs');
   const body = response?.data;

   if (Array.isArray(body)) return body;
   if (Array.isArray(body?.pdvs)) return body.pdvs;
   if (Array.isArray(body?.data?.pdvs)) return body.data.pdvs;
   if (Array.isArray(body?.data)) return body.data;
   return [];
}
